import { connect } from 'react-redux';
import {updateProfile} from '../actions/profile';
import ProfilePage from '../components/pages/ProfilePage';

const mapStateToProps = ({profileReducer},ownProps) => {
	return {
		...ownProps,
		uid : profileReducer.uid,
		fetchingState:profileReducer.fetchingState,
		profileReducer
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onSubmit : (value,id)=>{
			dispatch(updateProfile(value,id));
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);